module.exports = __webpack_public_path__ + "img/图层 8.09a8075e.png";